import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { BlueprintIntegrationAttachment } from "types/generated";

const IntegrationUsedByTableNameCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<BlueprintIntegrationAttachment>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellLink href={`/blueprint/${blueprint.blueprintID}`}>
        {blueprint.blueprintName}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default IntegrationUsedByTableNameCell;
